var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",staticStyle:{"position":"relative"}},[_vm._m(0),_c('Echart',{staticStyle:{"margin-top":"-100px"},attrs:{"options":_vm.chartOption,"width":"100%","height":"800px"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-line"},[_c('div',{staticClass:"title1"},[_vm._v("平均到货时长")]),_c('div',{staticStyle:{"position":"absolute","right":"0"}},[_vm._v("单位：小时")])])
}]

export { render, staticRenderFns }